module.exports = __webpack_public_path__ + "media/icons/close-cd08164f.png";